import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuInternal.sass';

const MenuAntioquia = () => (
  <div className="row MenuInternal --antioquia">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/tour-overview">
                RESUMEN
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/itinerary/start">
                ITINERARIO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/package-and-price">
                PAQUETES Y PRECIO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/upgrades-and-prices">
                ASCENSOS Y PRECIOS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/hotels">
                HOTELES
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/travel-details">
                DETALLES DEL VIAJE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/antioquia-mtb/important-info">
                INFORMACIÓN IMPORTANTE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/booknow/antioquia-mtb">
                RESERVAR AHORA
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuAntioquia;